

export function getSubstringAfterLastComma(input: string): string {
  // Find the last occurrence of a comma
  const lastCommaIndex = input.lastIndexOf(",");

  if (lastCommaIndex === -1) {
    return input;
  }

  // Extract the substring after the last comma and trim any leading/trailing spaces
  return input.substring(lastCommaIndex + 1).trim();
}
